import React from 'react';
import { defaultTemplate } from 'core/hoc';
import logoPositiveSvg from 'themes/img/logo-positive.svg';
import esDefaultSvg from 'themes/img/es-default.svg';

function NotFoundTemplate({ rootStore, t }) {
	return (
		<div className="container--404">
			<img
				className="w--280--px display--b align--h--center spc--bottom--xlrg"
				src={logoPositiveSvg}
				alt="Logo"
			/>
			<div className="w--400--px align--h--center type--center">
				<img className="display--b spc--bottom--med spc--top--med" src={esDefaultSvg} />
				<p className="spc--bottom--med w--250--px align--h--center">{t('NOTFOUND')}</p>
				<button
					className="btn btn--med btn--primary"
					onClick={() => rootStore.routerStore.goTo('master.app.main.home')}
				>
					{t('HOME')}
				</button>
			</div>
		</div>
	);
}

export default defaultTemplate(NotFoundTemplate);
